module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIyMiIgdmlld0JveD0iMCAwIDE1IDIyIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggc3Ryb2tlPSIjRkVGRUZFIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEuNTE3IDMuODdWMS41MTdoMTEuNzY1VjMuODdsLTQuNzUgNy4wOCA0Ljc1IDYuOTk0djIuNDRIMS41MTd2LTIuNDRsNC43MDYtNi45OTN6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRkVGRUZFIiBkPSJNNC41NiA1LjMxOGg1LjY1OEw3LjM3NiA5LjU1NSA0LjU2IDUuMzE4em0tMS4zMDcgMTMuMzN2LS4xNzRsLjkxNC0xLjM2IDYuNDczLjAzLjkwNyAxLjMzNHYuMTdIMy4yNTN6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/icons/hour-glass-medium.svg
// module id = 1777
// module chunks = 2